var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-box" }, [
    _c(
      "div",
      { key: _vm.index, staticClass: "box", on: { click: _vm.onclick } },
      [
        _c(
          "div",
          { attrs: { id: "itxst_" + _vm.indexStr } },
          _vm._l(_vm.tempTags, function(item, i) {
            return _c("div", { key: i, staticClass: "dis-tab" }, [
              _c("div", [_vm._v(_vm._s(item))]),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-close",
                on: {
                  click: function($event) {
                    return _vm.removeTag(i, item)
                  }
                }
              })
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowInput,
              expression: "isShowInput"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentVal,
              expression: "currentVal"
            }
          ],
          ref: "inputTag",
          staticClass: "input-tag",
          attrs: {
            placeholder: _vm.placeholder,
            maxlength: "20",
            type: "text"
          },
          domProps: { value: _vm.currentVal },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.addTags.apply(null, arguments)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.currentVal = $event.target.value
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _vm.isRepeat
      ? _c("div", { staticStyle: { color: "#F77073" } }, [
          _vm._v("\n    " + _vm._s(_vm.tmpRepeatMsg) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca1615e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca1615e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/form/input-tag.vue
// module id = U+mh
// module chunks = 2